import { ComponentType, memo } from 'react';

interface OnboardingManagerProps {
  onboardingFlows: ComponentType[];
}

export const OnboardingManager = memo(function OnboardingManager({ onboardingFlows }: OnboardingManagerProps) {
  return (
    <>
      {onboardingFlows.map((Flow, idx) => (
        <Flow key={idx} />
      ))}
    </>
  );
});
